import { render, staticRenderFns } from "./createStore.vue?vue&type=template&id=7bbbf7e4&"
import script from "./createStore.vue?vue&type=script&lang=js&"
export * from "./createStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports